/* SoftSins Startseite v2 – Animationen & Interaktion (vanilla JS, keine Abhängigkeiten) */
(function () {
  var COVERS = [
    { title: 'Seine letzten Worte waren wie Nadelstiche', tags: 'Obsession · Gefährliche Anziehung' },
    { title: 'Der Teufel meines Verlangens', tags: 'Verbotenes Verlangen · Slow Burn' },
    { title: 'Toxische Liebe schmeckt am besten', tags: 'Macht · Toxic Love · Enemies to Lovers' }
  ];
  var KEYS = ['fanSec', 'fanStage', 'fanL', 'fanC', 'fanR', 'fanSteps', 'fanHint', 'marquee', 'scStage', 'scBook', 'scFlick',
    'coverStack', 'seam', 'glare', 'stepsWrap', 'stepFill', 'waveF', 'ctaSec', 'mBar', 'coverNum', 'coverTitle', 'coverTags'];
  var cl = function (v) { return Math.max(0, Math.min(1, v)); };

  function init(root) {
    var R = {};
    KEYS.forEach(function (k) { R[k] = root.querySelector('[data-ref="' + k + '"]'); });
    var motion = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var cycle = Math.max(1.5, parseFloat(root.getAttribute('data-cycle')) || 3.5);
    var st = { playing: false, faq: 0, cover: 0, menu: false };
    var z = 10, timer = null, heroStage = -1, stepAct = -2, barShown = null;

    function each(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

    function setMenu(open) {
      st.menu = open;
      each('[data-menu-open]', function (el) { el.style.display = open ? 'contents' : 'none'; });
      each('[data-menu-closed]', function (el) { el.style.display = open ? 'none' : 'contents'; });
    }
    function setPlay(on) {
      st.playing = on;
      each('[data-play-on]', function (el) { el.style.display = on ? 'contents' : 'none'; });
      each('[data-play-off]', function (el) { el.style.display = on ? 'none' : 'contents'; });
    }
    function setFaq(i) {
      st.faq = st.faq === i ? -1 : i;
      each('[data-faq-body]', function (el) { el.style.display = +el.getAttribute('data-faq-body') === st.faq ? 'block' : 'none'; });
      each('[data-faq-icon]', function (el) { el.textContent = +el.getAttribute('data-faq-icon') === st.faq ? '−' : '+'; });
    }
    function updateCoverUi() {
      each('[data-action="pick"]', function (b) {
        var on = +b.getAttribute('data-i') === st.cover;
        b.style.background = on ? '#f2b6d0' : 'transparent';
        b.style.color = on ? '#2a1426' : 'rgba(244,235,240,.82)';
        b.style.borderColor = on ? '#f2b6d0' : 'rgba(244,235,240,.22)';
      });
      if (R.coverNum) R.coverNum.textContent = st.cover + 1;
      if (R.coverTitle) R.coverTitle.textContent = COVERS[st.cover].title;
      if (R.coverTags) R.coverTags.textContent = COVERS[st.cover].tags;
    }
    // Höhe von Titel/Tags auf den längsten Text fixieren, damit beim Cover-Wechsel nichts springt
    function lockCoverText() {
      [['coverTitle', 'title'], ['coverTags', 'tags']].forEach(function (p) {
        var el = R[p[0]]; if (!el || !el.parentNode) return;
        var box = el.parentNode, cur = el.textContent, max = 0;
        box.style.minHeight = '';
        COVERS.forEach(function (c) { el.textContent = c[p[1]]; max = Math.max(max, box.offsetHeight); });
        el.textContent = cur;
        box.style.minHeight = max + 'px';
      });
    }
    function showCover(n) {
      if (n === st.cover || !R.coverStack) return;
      var next = R.coverStack.children[n]; if (!next) return;
      next.style.zIndex = ++z;
      if (motion && next.animate) {
        var ease = 'cubic-bezier(.7,0,.2,1)', dur = 1150;
        var a = next.animate([{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0% 0 0)' }], { duration: dur, easing: ease });
        a.onfinish = function () { next.style.clipPath = 'none'; };
        if (R.seam) R.seam.animate([{ left: '0%', opacity: 0 }, { opacity: 1, offset: 0.12 }, { opacity: 1, offset: 0.88 }, { left: '100%', opacity: 0 }], { duration: dur, easing: ease });
        if (R.scFlick) R.scFlick.animate([{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(24deg) translateZ(10px)', offset: 0.42 }, { transform: 'rotateY(-5deg)', offset: 0.78 }, { transform: 'rotateY(0deg)' }], { duration: 1400, easing: 'cubic-bezier(.45,0,.25,1)' });
        if (R.glare) R.glare.animate([{ transform: 'translateX(-130%)' }, { transform: 'translateX(230%)' }], { duration: 900, delay: 900, easing: 'ease-in-out' });
      }
      st.cover = n;
      updateCoverUi();
    }
    function schedule() {
      clearTimeout(timer);
      if (!motion) return;
      timer = setTimeout(function () { showCover((st.cover + 1) % COVERS.length); schedule(); }, cycle * 1000);
    }

    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-action]'); if (!el || !root.contains(el)) return;
      var a = el.getAttribute('data-action');
      if (a === 'toggleMenu') setMenu(!st.menu);
      else if (a === 'closeMenu') setMenu(false);
      else if (a === 'togglePlay') setPlay(!st.playing);
      else if (a === 'faq') setFaq(+el.getAttribute('data-i'));
      else if (a === 'pick') { showCover(+el.getAttribute('data-i')); schedule(); }
    });
    var lockT = null;
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 900 && st.menu) setMenu(false);
      clearTimeout(lockT); lockT = setTimeout(lockCoverText, 150);
    });
    lockCoverText();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(lockCoverText);
    window.addEventListener('load', lockCoverText);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.style.opacity = 1; e.target.style.transform = 'none'; io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      each('[data-reveal]', function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) return;
        el.style.opacity = 0; el.style.transform = 'translateY(24px)';
        el.style.transition = 'opacity .8s cubic-bezier(.22,.7,.2,1), transform .8s cubic-bezier(.22,.7,.2,1)';
        io.observe(el);
      });
    }

    var books = [];
    if (R.fanC && R.fanL && R.fanR) {
      var mk = function (el, side, o) {
        var q = function (k) { return el.querySelector('[data-l="' + k + '"]'); };
        return { el: el, side: side, o: o, blank: q('blank'), sketch: q('sketch'), color: q('color'), frame: q('frame'), title: q('title'), foil: q('foil') };
      };
      books = [mk(R.fanC, 0, 0), mk(R.fanL, -1, 0.05), mk(R.fanR, 1, 0.09)];
    }

    function frame(t) {
      var vh = window.innerHeight;
      var s = motion ? Math.sin(t / 1800) : 0;

      if (R.marquee) { var w = R.marquee.scrollWidth / 2; R.marquee.style.transform = 'translateX(' + (motion ? -((t * 0.035) % w) : 0) + 'px)'; }

      var fs = R.fanSec, stg = R.fanStage;
      if (fs && stg) {
        var r = fs.getBoundingClientRect();
        if (r.bottom > -50 && r.top < vh + 50) {
          var p = motion ? cl(-r.top / Math.max(1, r.height - vh)) : 1;
          var W = stg.clientWidth, H = stg.clientHeight;
          var sc = Math.max(0.2, Math.min(1, (H - 16) / 340, W / 420));
          var e = 1 - Math.pow(1 - cl(p / 0.32), 3);
          var spread = e * Math.min(250 * sc, W / 2 - 46 * sc) + (1 - e) * 34 * sc;
          books.forEach(function (b) {
            var q = p - b.o;
            if (b.side === 0) b.el.style.transform = 'translateY(' + ((-e * 12) + s * 6) * sc + 'px) rotateY(' + s * 6 + 'deg) scale(' + (sc * (1 + e * 0.04)).toFixed(3) + ')';
            else b.el.style.transform = 'translate(' + b.side * spread + 'px, ' + (22 - e * 6) * sc + 'px) rotateY(' + (-b.side * (12 + e * 16)) + 'deg) rotateZ(' + b.side * (2 + e * 6) + 'deg) scale(' + sc.toFixed(3) + ')';
            if (b.blank) b.blank.style.opacity = (1 - cl((q - 0.2) / 0.12)).toFixed(3);
            b.sketch.style.opacity = (cl((q - 0.04) / 0.1) * (1 - cl((q - 0.36) / 0.1))).toFixed(3);
            var c = cl((q - 0.22) / 0.26), a = -30 + c * 130;
            var m = 'linear-gradient(35deg, #000 ' + a.toFixed(1) + '%, transparent ' + (a + 32).toFixed(1) + '%)';
            b.color.style.webkitMaskImage = m; b.color.style.maskImage = m;
            b.color.style.opacity = cl(c * 4).toFixed(3);
            b.color.style.transform = 'scale(' + (1.05 - c * 0.05).toFixed(4) + ')';
            var ins = ((1 - cl((q - 0.44) / 0.12)) * 50).toFixed(2);
            b.frame.style.clipPath = 'inset(' + ins + '% ' + ins + '% ' + ins + '% ' + ins + '%)';
            b.title.style.clipPath = 'inset(0 ' + ((1 - cl((q - 0.54) / 0.18)) * 100).toFixed(2) + '% 0 0)';
            b.foil.style.transform = 'translateX(' + (-120 + cl((q - 0.76) / 0.16) * 320).toFixed(1) + '%)';
          });
          if (R.fanHint) R.fanHint.style.opacity = (1 - cl(p / 0.06)).toFixed(3);
          var stage = p < 0.05 ? 0 : p < 0.26 ? 1 : p < 0.46 ? 2 : p < 0.7 ? 3 : p < 0.93 ? 4 : 5;
          if (stage !== heroStage && R.fanSteps) {
            heroStage = stage;
            Array.prototype.forEach.call(R.fanSteps.children, function (el, i) {
              el.style.color = i <= stage ? '#f4ebf0' : 'rgba(244,235,240,.45)';
              el.style.borderBottomColor = (i === stage || stage === 5) ? '#f2b6d0' : 'transparent';
            });
          }
        }
      }

      if (R.scBook && R.scStage) {
        var r2 = R.scStage.getBoundingClientRect();
        if (r2.bottom > 0 && r2.top < vh) {
          var sc2 = Math.min(1, R.scStage.clientWidth / 400, R.scStage.clientHeight / 470);
          var sp = motion ? cl((vh - r2.top) / (vh + r2.height)) - 0.5 : 0;
          R.scBook.style.transform = 'scale(' + sc2.toFixed(3) + ') translateY(' + s * -8 + 'px) rotateX(' + (6 + s * 2) + 'deg) rotateY(' + (-24 + s * 6 + sp * 30) + 'deg)';
        }
      }

      if (R.stepsWrap) {
        var r3 = R.stepsWrap.getBoundingClientRect();
        if (r3.bottom > -100 && r3.top < vh + 100) {
          var mark = vh * 0.62;
          if (R.stepFill) R.stepFill.style.height = (cl((mark - r3.top - 22) / Math.max(1, r3.height - 44)) * 100).toFixed(1) + '%';
          var steps = R.stepsWrap.querySelectorAll('[data-step]'), act = -1;
          Array.prototype.forEach.call(steps, function (el, i) { if (el.getBoundingClientRect().top < mark) act = i; });
          if (act !== stepAct) {
            stepAct = act;
            Array.prototype.forEach.call(steps, function (el, i) {
              var n = el.querySelector('[data-n]'), cd = el.querySelector('[data-card]'), on = i <= act, cur = i === act;
              n.style.background = on ? '#2a1a2c' : '#f5edf0';
              n.style.color = on ? '#f5edf0' : '#2a1a2c';
              n.style.borderColor = on ? '#2a1a2c' : 'rgba(42,26,44,.2)';
              cd.style.borderColor = cur ? 'rgba(138,63,106,.4)' : 'rgba(42,26,44,.08)';
              cd.style.boxShadow = cur ? '0 24px 48px -28px rgba(90,40,70,.45)' : 'none';
              cd.style.transform = cur ? 'translateX(4px)' : 'none';
            });
          }
        }
      }

      if (R.mBar && fs) {
        var heroDone = fs.getBoundingClientRect().bottom < vh * 0.4;
        var ctaIn = R.ctaSec && R.ctaSec.getBoundingClientRect().top < vh;
        var show = heroDone && !ctaIn && !st.menu;
        if (show !== barShown) { barShown = show; R.mBar.style.transform = show ? 'translateY(0)' : 'translateY(160%)'; }
      }

      if (R.waveF) {
        var playing = st.playing && motion;
        Array.prototype.forEach.call(R.waveF.children, function (b, i) {
          var base = 0.25 + 0.6 * Math.abs(Math.sin(i * 0.9) * Math.cos(i * 0.37));
          var v = playing ? 0.15 + 0.85 * Math.abs(Math.sin(t / 210 + i * 0.55) * Math.sin(t / 520 + i * 0.31)) : base;
          b.style.transform = 'scaleY(' + v.toFixed(3) + ')';
          b.style.opacity = playing ? 1 : 0.75;
        });
      }
    }

    (function loop(t) { frame(t || 0); requestAnimationFrame(loop); })();
    schedule();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ssv2]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
